import type { BackendPeriodShape } from '@/components/filter/constants';
import { Period } from '@enmon/commons/lib/enmon';
import type { DateRangePickerValue } from '../DateRangePicker';
import { getPeriodFromPredefined } from './getPeriodFromPredefined';
import { getPeriodFromYear } from './getPeriodFromYear';
import { getTimeValueUnitRange } from './getPeriodFromTimeValueUnit';
import { getPeriodFromCustomDate } from './getPeriodFromCustomDate';

export const getBackendPeriodShapeFromRangePickerValue = (
  value: DateRangePickerValue | undefined,
): BackendPeriodShape => {
  if (!value) return {};

  const { predefined, year, timeValue, timeUnit, from, to, timeWindowShift } = value;
  let dateFrom: Date | undefined;
  let dateTo: Date | undefined;

  if (predefined) {
    const predefinedPeriodRange = getPeriodFromPredefined(predefined, timeWindowShift);
    dateFrom = predefinedPeriodRange.dateFrom.toDate();
    dateTo = predefinedPeriodRange.dateTo.toDate();
  }

  if (year) {
    const yearRange = getPeriodFromYear(year, timeWindowShift);
    dateFrom = yearRange.dateFrom.toDate();
    dateTo = yearRange.dateTo.toDate();
  }

  if (timeValue && timeUnit) {
    const timeValueUnitRange = getTimeValueUnitRange(timeValue, timeUnit, timeWindowShift);
    dateFrom = timeValueUnitRange.dateFrom.toDate();
    dateTo = timeValueUnitRange.dateTo.toDate();
  }

  if (from && to) {
    const customDateRange = getPeriodFromCustomDate(from, to, timeWindowShift);
    dateFrom = customDateRange.dateFrom.toDate();
    dateTo = customDateRange.dateTo.toDate();
  }

  return {
    period: Period.Custom,
    from: dateFrom,
    to: dateTo,
  };
};
